import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Terms from "@/pages/Terms";

export const Route = createFileRoute("/_site/terms")({
  head: () => ({
    ...seo({
      title: "Terms of Use | Kodiak Structures & Exteriors",
      description:
        "Terms of Use for the Kodiak Structures & Exteriors website.",
      path: "/terms",
    }),
  }),
  component: Terms,
});
